import { PhoneInputController } from "@/src/components/PhoneInputController/PhoneInputController";
import { IFormApplicationProps } from "@/src/types/IApplyOnline";
import { FC } from "react";

const FormApplicationFast: FC<IFormApplicationProps & { handleFocus?: () => void }> = ({
  register,
  control,
  errors,
  handleFocus,
}) => {
  return (
    <div className="form-application-fast">
      <div className="form-application-header">
        <h1 className="form-application-header-title">Быстрая заявка</h1>
        {(errors.fullname || errors.phone || errors.email) && (
          <span className="form-application-header-error">В одном из полей допущена ошибка!</span>
        )}
      </div>
      <div className="form-application-body">
        <input
          className="form-application-body-input fullname"
          type="text"
          placeholder="Полное Имя:"
          {...register("fullname", {
            required: "Name is required",
            minLength: { value: 2, message: "Minimum 2 characters" },
          })}
          onFocus={handleFocus}
        />
        <div className="form-application-body-input-phone-wrapper">
          <PhoneInputController
            name="phone"
            control={control}
            rules={{ required: "Phone is required" }}
            onFocus={handleFocus}
          />
        </div>
        <input
          className="form-application-body-input email"
          type="email"
          placeholder="Email:"
          {...register("email", {
            required: "Email is required",
            pattern: {
              value: /^\S+@\S+$/i,
              message: "Invalid email address",
            },
          })}
          onFocus={handleFocus}
        />
      </div>
    </div>
  );
};

export default FormApplicationFast;
